import React, {Fragment, useState, useEffect} from 'react';
import MapSidebar from './MapSidebar';
import Map from "./Map";
import {geolocated} from "react-geolocated";
import axios from 'axios';
import {toWKT} from "../helpers";

var _ = require('lodash');

// Toggle Switch Component
const ViewToggle = ({viewType, onChange}) => {
    const [lang, setLang] = useState('');

    useEffect(() => {
        // Get the HTML lang attribute
        const htmlLang = $('html').attr('lang');
        setLang(htmlLang);
    }, [])

    return (
        <div className="view-toggle-container" style={{
            position: 'absolute',
            top: '10px',
            left: lang === 'dv' ? '10px' : 'unset',
            right: lang === 'en' ? '10px' : 'unset',
            zIndex: 1000,
            background: "rgba(255,255,255, 0.8)",
            padding: '10px',
            borderRadius: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
        }}>
            <div className="toggle-switch">
                 <span className={viewType === 'projects' ? 'active fw-medium' : 'fw-medium'}
                       style={{
                           margin: '0 10px',
                           color: viewType === 'projects' ? '#19aef7' : '#212529',
                           cursor: 'pointer'
                       }}
                       onClick={() => onChange('projects')}>
                      {lang === 'dv' ? "ޕްރޮޖެކްޓްތައް" : "Projects"}
                </span>
                <label className="switch"
                       style={{position: 'relative', display: 'inline-block', width: '40px', height: '20px'}}>
                    <input
                        type="checkbox"
                        checked={viewType === 'facilities'}
                        onChange={() => onChange(viewType === 'projects' ? 'facilities' : 'projects')}
                        style={{opacity: 0, width: 0, height: 0}}
                    />
                    <span className="slider" style={{
                        position: 'absolute',
                        cursor: 'pointer',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: viewType === 'projects' ? '#2196F3' : '#2196F3',
                        transition: '.4s',
                        borderRadius: '34px'
                    }}>
                        <span className="slider-button" style={{
                            position: 'absolute',
                            content: '',
                            height: '16px',
                            width: '16px',
                            left: viewType === 'projects' ? '22px' : '2px',
                            bottom: '2px',
                            backgroundColor: 'white',
                            transition: '.4s',
                            borderRadius: '50%'
                        }}/>
                    </span>
                </label>
                <span className={viewType === 'facilities' ? 'active fw-medium' : 'fw-medium'}
                      style={{
                          margin: '0 10px',
                          color: viewType === 'facilities' ? '#19aef7' : '#212529',
                          cursor: 'pointer'
                      }}
                      onClick={() => onChange('facilities')}>
                    {lang === 'dv' ? "ފެސިލިޓީތައް" : "Facilities"}
                </span>
            </div>
        </div>
    );
};

// Home Button Component
const HomeButton = () => {
    const [lang, setLang] = useState('');

    useEffect(() => {
        // Get the HTML lang attribute
        const htmlLang = $('html').attr('lang');
        setLang(htmlLang);
    }, []);

    return (
        <div className="home-button-container" style={{
            position: 'absolute',
            top: '10px',
            left: lang === 'dv' ? '220px' : 'unset',
            right: lang === 'en' ? '220px' : 'unset',
            zIndex: 1000,
            background: "rgba(255,255,255, 0.8)",
            padding: '5px 10px',
            borderRadius: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
        }}>
            <a
                href="/"
                className="btn btn-sm"
                style={{
                    backgroundColor: 'transparent',
                    color: '#a6a4a4',
                    border: "none",
                    fontSize: '12px',
                    padding: '5px 10px',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '5px'
                }}
            >
                <i className="fa fa-home fa-2x" aria-hidden="true"></i>
            </a>
        </div>
    );
};

class App extends React.Component {

    state = {
        raw_locations: [],
        locations: [],
        center: null,
        selection: null,
        category: null,
        zoom: 10,
        preSelection: null,
        active_category: null,
        categories: [],
        status: null,
        island: null,
        islandData: null,
        viewType: 'projects', // Default view type
    };

    _queryLocations = (bounds) => {
        // Choose API endpoint based on viewType
        const endpoint = this.state.viewType === 'projects' ? '/map-locations' : '/map-facilities';

        axios.get(window.Laravel.apiUrl + endpoint, {
            params: {
                bounds: toWKT(bounds) || null,
                category: this.state.filter,
                limit: -1,
                lang: $('html').attr('lang'),
                status: this.state.status,
                island: this.state.island,
            },
        })
            .then(res => {
                let selection = this.state.preSelection ? res.data.locations.filter((location) => {
                    return (location.id === parseInt(this.state.preSelection))
                })[0] : this.state.selection;

                let locations = this.state.active_category ? res.data.locations.filter((location) => {
                    return location.categories.includes(this.state.active_category);
                }) : res.data.locations;

                this.setState({
                    raw_locations: res.data.locations,
                    locations: locations,
                    selection: selection,
                    preSelection: null,
                    categories: res.data.categories,
                    islandData: res.data.island,
                    center: res.data.island ? {
                        lat: res.data.island.coords.coordinates[1],
                        lng: res.data.island.coords.coordinates[0]
                    } : this.state.center,
                });
            });
    };

    componentDidMount() {

        let url = new URL(window.location.href);
        let model_id = url.searchParams.get('id');
        let category = url.searchParams.get('category');
        let lat = url.searchParams.get('lat');
        let lng = url.searchParams.get('lng');
        let zoom = url.searchParams.get('zoom') || 12;
        let statusFromUrl = url.searchParams.get('status');
        let islandFromUrl = url.searchParams.get('island');
        let typeFromUrl = url.searchParams.get('type');

        if (statusFromUrl) {
            statusFromUrl = statusFromUrl.toUpperCase();
        }

        let center = lat && lng ? {lat: parseFloat(lat), lng: parseFloat(lng)} : {lat: 4.175804, lng: 73.509337};
        let preSelection = model_id || null;
        zoom = parseInt(zoom);

        this.setState({center, preSelection, zoom, active_category: category, status: statusFromUrl, island: islandFromUrl, viewType: typeFromUrl},
            () => this._queryLocations()
        );
    }

    _filterLocations = (category = null) => {
        let filtered = this.state.raw_locations;

        if (category !== null) {
            filtered = this.state.raw_locations.filter((location) => {
                return location.categories.includes(category);
            });
            this.setState({locations: filtered, selection: null, active_category: category});
        } else {
            this.setState({locations: filtered, filter: null, selection: null, active_category: null});
        }
    };

    _updateSelection = (id) => {
        if (id) {
            let selected = _.find(this.state.locations, (location) => {
                return location.id == id
            });
            this.setState({
                selection: selected,
                center: {lat: selected.lat, lng: selected.lng},
            });
        } else {
            this.setState({
                selection: null,
            });
        }
    };

    _findSelection = (location, zoom) => {
        this.setState({
            //raw_locations: this.state.raw_locations.push(location),
            //locations: this.state.locations.push(location),
            center: {lat: location.lat, lng: location.lng},
            selection: location,
            zoom: zoom
        });
    };

    _updateZoomCenter = (center, zoom) => {
        this.setState({zoom, center});
    };

    _updateStatus = (status) => {
        return this.setState({status});
    };

    _updateIsland = (island) => {
        // Clear island data if empty
        if (!island) {
            return this.setState({
                island: null,
                islandData: null
            });
        } else {
            return this.setState({island}, () => {
                // After setting the island ID, make sure to query for the data
                this._queryLocations(null);
            });
        }
    };

    _toggleViewType = (viewType) => {
        this.setState({viewType}, () => {
            // Reload locations with new view type
            this._queryLocations(null);
        });
    };

    render() {
        return (
            <React.Fragment>
                <ViewToggle
                    viewType={this.state.viewType}
                    onChange={(viewType) => this._toggleViewType(viewType)}
                />
                <HomeButton/>
                <MapSidebar
                    active_category={this.state.active_category}
                    categories={this.state.categories}
                    locations={this.state.locations}
                    selection={this.state.selection}
                    updateSelection={(id) => this._updateSelection(id)}
                    findSelection={(location, zoom) => this._findSelection(location, zoom)}
                    filterLocation={(type) => this._filterLocations(type)}
                />
                <Map
                    categories={this.state.categories}
                    updateZoomCenter={(center, zoom) => this._updateZoomCenter(center, zoom)}
                    zoom={this.state.zoom}
                    query={(bounds) => this._queryLocations(bounds)}
                    locations={this.state.locations}
                    selection={this.state.selection}
                    updateSelection={(id) => this._updateSelection(id)}
                    center={this.state.center}
                    status={this.state.status}
                    island={this.state.island}
                    islandData={this.state.islandData}
                    updateStatus={(status) => this._updateStatus(status)}
                    updateIsland={(island) => this._updateIsland(island)}
                    viewType={this.state.viewType}
                />
            </React.Fragment>
        )
    }
}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
})(App);
